export default "__VITE_ASSET__DXAv3TjA__"